import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import type { Router } from 'vue-router'

export default defineNuxtPlugin((nuxtApp) => {
  if (!Capacitor.isNativePlatform()) {
    return
  }

  const router = nuxtApp.$router as Router
  let isNotified = false

  App.addListener('backButton', async ({ canGoBack }) => {
    if (canGoBack) {
      return router.back()
    } else if(isNotified) {
      isNotified = false
      console.log('Exiting app')
      await App.exitApp()
      return
    } else {
      console.log('Back button pressed, showing exit prompt')
      isNotified = true
      return notify({
        id: 'exit-prompt',
        text: 'Press back again to exit',
        timeout: 1000,
      })
    }
  })
})
